import React from 'react'

const Footer = () => (
    <footer id="footer">
        <div className="inner">
        <p className = "siret">Numéro de siret : 834 187 981 00016</p>
            <ul className="copyright">
                <li>&copy; Vincent Bourdeau - 2018</li>
            </ul>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js